

















































import { Component, Vue, Ref } from 'vue-property-decorator';
import { UNIT_MAIN_PAYCHECK_LINE_TEMPLATES, SAVE_MAIN_PAYCHECK_LINE_TEMPLATE } from '@/queries/MainPaycheckLineTemplate';
import { SmartQuery } from 'vue-apollo-decorator';
import { CURRENT_UNIT } from '@/queries/Application';
import { GQL_currentUnit_currentUnit } from '@/queries/__generated__/currentUnit';
import { UnsavedChanges } from '@/decorators/unsaved-changes';
import i18n from '@/i18n';
import MainPaycheckLineTemplateForm from '@/components/MainPaycheckLineTemplate/MainPaycheckLineTemplateForm.vue';
import PermissionService from '@/utils/permission-service';
import gql from 'graphql-tag';

const IMPORT_MAIN_PAYCHECK_LINE_TEMPLATE_TO_UNIT = gql`
  mutation importMainPaycheckLineTemplateToUnit($unitId: ID!) {
    importMainPaycheckLineTemplateToUnit(input: { unitId: $unitId }) {
      mainPaycheckLineTemplates { id }
    }
  }
`;

@Component({
  components: {
    MainPaycheckLineTemplateForm,
  },
})
export default class UnitMainPaycheckLineTemplate extends Vue {
  @SmartQuery({ query: CURRENT_UNIT }) private currentUnit!: GQL_currentUnit_currentUnit;
  private UNIT_MAIN_PAYCHECK_LINE_TEMPLATES = UNIT_MAIN_PAYCHECK_LINE_TEMPLATES;
  private IMPORT_MAIN_PAYCHECK_LINE_TEMPLATE_TO_UNIT = IMPORT_MAIN_PAYCHECK_LINE_TEMPLATE_TO_UNIT;

  @UnsavedChanges<UnitMainPaycheckLineTemplate>({
    saveAndContinue() {
      return this.saveAndContinue();
    },
  }) public dirtyForm = false;

  @Ref('mainPaycheckLineTemplateForm') private readonly form!: MainPaycheckLineTemplateForm;

  private PermissionService = PermissionService;

  private get editable(): boolean {
    return PermissionService.check('canUpdateUnit');
  }

  private saveAndContinue() {
    if (!this.editable) return false;

    return this.$apollo.mutate({
      mutation: SAVE_MAIN_PAYCHECK_LINE_TEMPLATE,
      variables: this.form.formatDataForMutation,
    }).then(() => {
      // i18n.t used instead of this.$t because function is async and component calling it might be destroyed, making 'this' undefined
      this.$sMessage.success(i18n.t('Message.saveSuccess'));
      return true;
    }).catch(() => {
      // i18n.t used instead of this.$t because function is async and component calling it might be destroyed, making 'this' undefined
      return false;
    });
  }
}
